// extracted by mini-css-extract-plugin
export default {"waysToStyleSimilarItems":"L40gS"};